import React, {useContext, useEffect, useState} from "react";

import Container from "react-bootstrap/Container";

import {Web3Context, ContractsContext} from "../contexts/Context";
import Lock from "../components/Lock";
import NFT from "../components/NFT";

import Logger from "../components/utils/Logger";

const MyNFTs = () => {
  const [locks, setLocks] = useState([]);
  const [owned, setOwned] = useState([]);
  const [reload, setReload] = useState(false);

  const web3Context = useContext(Web3Context);
  const contractsContext = useContext(ContractsContext);

  const {activeAccount} = web3Context;

  const reloadFunc = () => {
    setReload(true);
  };

  useEffect(() => {
    Logger.log("useEffect MyNFTs");
    const {contractNiftyEggsFarmer, contractNiftyEggsERC721} = contractsContext;

    const loadLocks = async () => {
      if (contractNiftyEggsFarmer) {
        const lockIds = await contractNiftyEggsFarmer.methods.getAccountLocks().call({from: activeAccount});

        let items = [];
        for (let i = 0; i < lockIds.length; i++) {
          const lockInfo = await contractNiftyEggsFarmer.methods.getLockInfo(lockIds[i]).call();
          items.push({id: lockIds[i], lockInfo: lockInfo});
        }

        Logger.log("Loaded locks", items);
        setLocks(items);
      }
    };

    const loadOwned = async () => {
      if (contractNiftyEggsERC721) {
        const ids = await contractNiftyEggsERC721.methods.ownedTokens().call({from: activeAccount});

        let items = [];
        for (let i = 0; i < ids.length; i++) {
          const uri = await contractNiftyEggsERC721.methods.tokenURI(ids[i]).call();
          items.push({id: ids[i], uri: uri});
        }

        Logger.log("Loaded owned", items);
        setOwned(items);
      }
    };

    loadLocks();
    loadOwned();
    setReload(false);
  }, [contractsContext, activeAccount, reload]);

  const farming = locks.map((item, index) =>
    <Lock key={item.id} lock={item.lockInfo} reloadFunc={reloadFunc}/>
  );

  const owning = owned.map((item, index) =>
    <div key={index} className="col-12 col-sm-6 col-lg-4 text-center">
      <NFT index={index} id={item.id} uri={item.uri}/>
    </div>
  );

  return (
    <div className="px-4 py-5 container-fluid">
      <div className="row no-gutters">
        <div className="col-12 col-md-10 offset-md-1">
          <div className="text-center mb-5">
            <h2>My NiftyEggs</h2>
          </div>
          <Container>
            <h4 className="mb-2">Currently farming:</h4>
            {farming && farming.length > 0 ?
              farming
              :
              <h6>You are not farming any NFTs yet...</h6>
            }
            <hr className="hr-line4 my-4"/>
          </Container>
          <Container>
            <h4 className="mb-2">Owned:</h4>
            {owning && owning.length > 0 ?
              <div className="row">{owning}</div>
              :
              <h6>You do not own any NFTs yet...</h6>
            }
          </Container>
        </div>
      </div>
    </div>
  )
};

export default MyNFTs;